import React from 'react';
import style from './style';

class Dropdown extends React.PureComponent {
	static Wrapper = ({children,...props}) => <style.Wrapper {...props}>{children}</style.Wrapper>;
	static Button = ({children,...props}) => <style.Button {...props}>{children}</style.Button>;
	static Content = ({children,...props}) => <style.Content {...props}>{children}</style.Content>;
	constructor(props){
    	super(props);
    	this.state = {
    		show : false
    	};
	}


	componentDidMount = ()=> {
		document.addEventListener('mousedown', this.handleClickOutside);
	  }
	
	  componentWillUnmount = ()=> {
	  	document.removeEventListener('mousedown', this.handleClickOutside);
	  }
	
	  /**
	   * Set the wrapper ref
	   */
	  setWrapperRef = (node) => {
	  	this.wrapperRef = node;
	  }
	
	  /**
	   * Alert if clicked on outside of element
	   */
	  handleClickOutside = (event) => {
	  	if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
	  		this.setState({show:false});
	  	}
	  }


	  render(){
    	const {
    		Wrapper : MyWrapper = Dropdown.Wrapper,
    		Button : MyButton = Dropdown.Button,
	  		Content : MyContent = Dropdown.Content,
	  		renderMenu = (menu)=>(
	  			<style.MenuItem key={menu}>
	  			{menu}
	  			</style.MenuItem>
	  		),
	  		menuItems = [],
	  		value = '',
	  		right=undefined,
	  		left=undefined,
	  		...props
    	} = this.props;
    	return (
	  		<MyWrapper {...props}>
	  			<div ref={this.setWrapperRef}>
	  				<MyButton onClick={()=>{
	  					this.setState({show:true});
	  				}}>{value}</MyButton>
	  				{
	  					this.state.show && 
						(
							<MyContent right={right} left={left}>
								{
									menuItems.map((menu,index)=>{
										return renderMenu(menu,index,(show)=>{
											this.setState({show});
										});
									})
								}
							</MyContent>
						)
	  				}
	  			</div>
    			
    			
    		</MyWrapper>);
	  }
}

export default Dropdown;